import { ApiService } from 'src/app/services/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIs } from '../config/api.constant';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InviteService {

  constructor(private apiService: ApiService) { }


  getInvitationList(data): Observable<any> {
    return this.apiService.get(APIs.getInvitationList, data).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

  getBPInvitationList(data): Observable<any> {
    return this.apiService.get(APIs.getBPInvitationList, data).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

  getInvitationDetail(data): Observable<any> {
    return this.apiService.get(APIs.getInvitationDetail, data).pipe(
      map((response) => {
        return response.data;
      })
    );
  }

  getHistoryDetail(data): Observable<any> {
    return this.apiService.post(APIs.getHistoryDetails, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getBPHistoryDetail(data): Observable<any> {
    return this.apiService.post(APIs.getBPHistoryDetails, data).pipe(
      map((response) => {
        return response;
      })
    );
  }



  getCompanyList(data): Observable<any> {
    return this.apiService.get(APIs.getCompanyListForHistory, data).pipe(
      map((response) => {
        return response?.list;
      })
    );
  }

  approveInvitation(data): Observable<any> {
    return this.apiService.post(APIs.approveInvitation, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getVmsAccessList(data): Observable<any> {
    return this.apiService.post(APIs.getVmsInvitationRights, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getVmsRequestHistory(data): Observable<any> {
    return this.apiService.post(APIs.getVmsRequestHistory, data).pipe(
      map((response) => {
        return response;
      })
    );
  }


  approveAccess(data): Observable<any> {
    return this.apiService.post(APIs.approveVmsAccessReqId, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GetVMSAccessPendingRequestAndHistoryList(data): Observable<any> {
    return this.apiService.post(APIs.GetVMSAccessPendingRequestAndHistoryList, data).pipe(
      map((response) => {
        return response;
      })
    );
  }
  GetVMSAccessHistoryList(data): Observable<any> {
    return this.apiService.post(APIs.getVmsRequestHistory, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getBridgePlusBuildingList(data) :Observable<any> {
    return this.apiService.get(APIs.getBridgePlusBuildingList,data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  createInvitationForExternalEmp(data):Observable<any>{
    return this.apiService.post(APIs.createVMSforExternalEmp,data).pipe(
      map((response) => {
        return response;
      })
    );

  }

  getMeetingPurpose():Observable<any>{
    return this.apiService.get(APIs.getVmsMeetingPurpose).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

}
